import { render, staticRenderFns } from "./ModalBilletInfo.vue?vue&type=template&id=4da7df4d&"
import script from "./ModalBilletInfo.vue?vue&type=script&lang=js&"
export * from "./ModalBilletInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports